import { Flex } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import { Routes } from '@constants/routes';
import Confetti from 'react-confetti';
import Container from './Container';

const Done = () => {
  return (
    <>
      <Confetti numberOfPieces={200} recycle={false} />
      <Container header="Congratulations!">
        <Body1>You've taken the first step to finding a Medicare plan that covers everything you need.</Body1>
        <Body1>One of our licensed Medicare Advisors will call you soon to discuss how we can help you further.</Body1>
        <Flex w="100%" pt={2}>
          <Button w="100%" href={Routes.index} variant={ButtonVariants.primary}>
            Homepage
          </Button>
        </Flex>
      </Container>
    </>
  );
};

export default Done;
